import { createContext, useContext } from "react";

/**
 * True inside an area's section rail. Page columns then sit at the left,
 * beside the rail, instead of centring themselves in what's left of the screen.
 */
export const InRailContext = createContext(false);
export const useInRail = () => useContext(InRailContext);
